(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["alfa-release-slider"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('alfa-release-slider')){
  customElements.define('alfa-release-slider',class extends HTMLElement{
    connectedCallback(){
      this.slides=Array.from(this.querySelectorAll('[data-release-slide]'));
      if(this.slides.length<2)return;
      this.index=0;this.timer=null;this.hovered=false;this.focused=false;
      this.abort=new AbortController();const opts={signal:this.abort.signal};
      this.reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused=this.reduced.matches;this.dots=Array.from(this.querySelectorAll('[data-release-dot]'));
      this.pauseButton=this.querySelector('[data-release-pause]');
      this.querySelector('[data-release-controls]').hidden=false;
      this.dots.forEach((dot,i)=>dot.addEventListener('click',()=>this.manual(i),opts));
      this.pauseButton.addEventListener('click',()=>{this.paused=!this.paused;this.sync();},opts);
      this.addEventListener('mouseenter',()=>{this.hovered=true;this.schedule();},opts);
      this.addEventListener('mouseleave',()=>{this.hovered=false;this.schedule();},opts);
      this.addEventListener('focusin',()=>{this.focused=true;this.schedule();},opts);
      this.addEventListener('focusout',e=>{if(!this.contains(e.relatedTarget)){this.focused=false;this.schedule();}},opts);
      document.addEventListener('visibilitychange',()=>this.schedule(),opts);
      this.reduced.addEventListener('change',e=>{if(e.matches){this.paused=true;this.sync();}},opts);
      this.addEventListener('shopify:block:select',e=>{const i=this.slides.indexOf(e.target.closest('[data-release-slide]'));if(i>=0)this.manual(i);},opts);
      this.sync();
    }
    show(i){this.index=(i+this.slides.length)%this.slides.length;this.slides.forEach((el,n)=>{el.hidden=n!==this.index;});this.dots.forEach((el,n)=>el.setAttribute('aria-current',String(n===this.index)));}
    manual(i){this.show(i);this.sync();}
    sync(){this.pauseButton.textContent=this.paused?'Play':'Pause';this.pauseButton.setAttribute('aria-label',this.paused?'Start banner rotation':'Pause banner rotation');this.schedule();}
    schedule(){clearInterval(this.timer);if(!this.paused)this.timer=setInterval(()=>{if(!this.paused&&!this.matches(':hover')&&!this.contains(document.activeElement)&&!document.hidden)this.show(this.index+1);},Number(this.dataset.interval)||6000);}
    disconnectedCallback(){clearInterval(this.timer);this.abort?.abort();}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
(() => {
  const desktop = window.matchMedia('(min-width: 1024px)');
  const setup = (root) => {
    root.querySelectorAll('.pdp-hero > .pdp-gallery').forEach((gallery) => {
      if (gallery.dataset.stickyReady) return;
      gallery.dataset.stickyReady = 'true';
      const update = () => {
        if (!desktop.matches) { gallery.style.removeProperty('--pdp-sticky-top'); return; }
        gallery.style.setProperty('--pdp-sticky-top', Math.min(24, window.innerHeight - gallery.getBoundingClientRect().height - 24) + 'px');
      };
      new ResizeObserver(update).observe(gallery);
      window.addEventListener('resize', update, { passive: true });
      desktop.addEventListener('change', update);
      update();
    });
  };
  setup(document);
  document.addEventListener('shopify:section:load', (event) => setup(event.target));
})();

(() => {
  const setup = (root) => root.querySelectorAll('[data-review-summary]').forEach((summary) => {
    if (summary.dataset.reviewReady) return;
    summary.dataset.reviewReady = 'true';
    const widget = summary.querySelector('.yotpo-widget-instance');
    const score = summary.querySelector('[data-review-score]');
    const empty = summary.querySelector('.pdp-review-empty');
    const update = () => {
      const button = widget.querySelector('.yotpo-sr-bottom-line-button[aria-label]');
      const match = button?.getAttribute('aria-label').match(/^([\d.]+) out 5 stars rating in total (\d+) reviews/);
      if (!match) return;
      const hasReviews = Number(match[2]) > 0;
      summary.classList.toggle('pdp-review-summary--empty', !hasReviews);
      empty.hidden = hasReviews;
      score.hidden = !hasReviews;
      const value = Number(match[1]).toFixed(1);
      if (score.textContent !== value) score.textContent = value;
    };
    new MutationObserver(update).observe(widget, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-label'] });
    summary.addEventListener('click', (event) => {
      if (!event.target.closest('.yotpo-sr-bottom-line-button')) return;
      const reviews = document.getElementById('product-reviews');
      if (!reviews) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      reviews.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    }, true);
    update();
  });
  setup(document);
  document.addEventListener('shopify:section:load', (event) => setup(event.target));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-details"] && !Shopify.designMode) return;
  try {
    
(() => {
  const enhance = (scope) => {
    scope.querySelectorAll('.product-details').forEach((section) => {
      const nav = section.querySelector('.product-details__nav');
      if (!nav || nav.dataset.ready) return;
      nav.dataset.ready = 'true';
      const headings = [...section.querySelectorAll('.product-details__body h2, .product-details__questions h3')];
      if (headings.length < 2) return;
      headings.slice(0, 7).forEach((heading, index) => {
        if (!heading.id) heading.id = section.closest('[id^="shopify-section-"]').id + '-story-' + index;
        const link = document.createElement('a');
        link.href = '#' + heading.id;
        link.textContent = heading.textContent.trim();
        nav.append(link);
      });
      nav.hidden = false;
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => enhance(document), {once: true});
  else enhance(document);
  document.addEventListener('shopify:section:load', (event) => enhance(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-videos"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('play', (event) => {
  if (!(event.target instanceof HTMLVideoElement) || !event.target.closest('.product-videos')) return;
  document.querySelectorAll('.product-videos video').forEach((video) => { if (video !== event.target) video.pause(); });
}, true);

  } catch(e) { console.error(e); }
})();
})();
